import React from 'react';

interface IAddressWrapper{
  addressToEdit: {},
  setAddressToEdit: (address: object) => {},
  setAddress: (params: any) => Promise<any>,
  getAddressServiceability: (params: FormData) => Promise<any>,
  getAllAddress: () => Promise<any>,
  addNewAddress: () => Promise<any>,
  editAddress: () => Promise<any>,
  setAddressType: Function ,
  addressType: '',
  cartAddressId: '',
  cartInfo: {totalSaved: 0},
  pincode: '',
  addressLoading: true,
  setAddressLoading: Function,
  totalAddressCount: 0,
  addresses: [],
  isShow: false,
  setIsShow: Function,
  isShipToAddressClick: false,
  setIsShipToAddressClick: Function,
  isPincodeBottomSheetVisible: boolean,
  setIsPincodeBottomSheetVisible: React.Dispatch<React.SetStateAction<boolean>>,
}
const addressContext = React.createContext({} as IAddressWrapper);

const { Provider, Consumer } = addressContext;

export const AddressContextProvider = Provider;

export const AddressContextConsumer = Consumer;

export const AddressContext = addressContext;
